import './ReleaseNoteBanner.scss'

import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  MODAL_TYPE,
  RELEASE_BANNER_VISIBILITY_DAYS,
} from 'src/constants/modal.constants'
import { useAppDispatch } from 'src/hooks/useAppDispatch'
import { getReleaseNotesAction } from 'src/redux/slice/GetReleaseNotesSlice'
import { setModal } from 'src/redux/slice/modalSlice'
import { RootState } from 'src/redux/stores/store'

export const ReleaseNoteBanner = () => {
  const [isVisible, setIsVisible] = useState(false)
  const dispatch = useAppDispatch()

  const { data: releaseNotesData } = useSelector(
    (state: RootState) => state.ReleaseNotes
  )

  const releaseNotes = releaseNotesData?.list
  const latestVersion = releaseNotesData?.latestVersion

  const getDaysDifferenceByVersionId = (versionId: string) => {
    return (
      (new Date().getTime() - new Date(versionId).getTime()) /
      (1000 * 3600 * 24)
    )
  }

  useEffect(() => {
    if (!releaseNotes) dispatch(getReleaseNotesAction())
    else {
      const latestRelease = releaseNotes[0]
      const daysDifference = getDaysDifferenceByVersionId(
        latestRelease?.versionId
      )
      if (daysDifference <= RELEASE_BANNER_VISIBILITY_DAYS) setIsVisible(true)
    }
  }, [dispatch, releaseNotes])

  const handleOpenModal = () => {
    dispatch(setModal({ property: MODAL_TYPE.RELEASE_NOTES_MODAL, value: {} }))
  }

  if (!isVisible || !releaseNotes) return null

  const getFormatReleaseDate = () => {
    if (releaseNotes?.[0]?.versionId) {
      return new Date(releaseNotes[0].versionId).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    }
    return ''
  }

  return (
    <Paper className="release-banner" elevation={2} sx={{ px: '10px' }}>
      <Typography variant="h6" className="release-banner-title">
        What’s New? {getFormatReleaseDate()} - Release {latestVersion}
      </Typography>

      <Typography variant="body1" className="release-banner-description">
        The Release Notes can be found{' '}
        <Link
          href="#"
          onClick={handleOpenModal}
          className="release-banner-link"
        >
          here
        </Link>
        , or by clicking on your initials at the top right corner and then the
        Release Name.
      </Typography>
    </Paper>
  )
}
